module.exports = __webpack_public_path__ + "img/2014-11_bloomberg_a.cc65b94c.png";